export default __webpack_public_path__ + "static/media/pana.6daf7054.svg";